


















































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { User } from '@/data/models/user.model';
import { Search, SortDirection } from '@/data/models/search.model';

@Component
export default class UtenteList extends Vue {
	
	@Inject('CrudService') crudService!: CrudService<User>;

	rows: User[] = [];
	advancedSearch: Search = new Search('user');
	loading: boolean = false;

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadUtenti() {

		const datareq = this.crudService.searchEntities(
			User,
			'user',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			User,
			'user',
			this.advancedSearch
		);
		
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	deleteUtente(item: User) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-utente-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			onConfirm: () => {
				this.crudService
					.deleteEntity(User, 'user', item)
					.then(() => {
						this.loadUtenti();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadUtenti();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadUtenti();
	}

}
